// componente che contiene tutti i metodi utilizzati per gestire i pannelli; queste funzioni sono richiamate esternamente
// dalle altre componenti che costituiscono tutto il blocco di gestione pannelli (availables-edit e availables-list)

import { Injectable } from '@angular/core';
import { Availables } from './availables.model';
import { Subject } from 'rxjs';

@Injectable()
export class AvailablesService {
  private availables: Availables[] = [];
  availablesChanged = new Subject<Availables[]>();
  availablesEditMode = new Subject<number>();
  availablesId
  public available: Availables
  public refresh = new Subject<any>();
  refresh$ = this.refresh.asObservable();
  
  constructor(
  ) { }

  // metodo richiamato alla modifica di un pannello; viene identificata la posizione nella tabella dell'elemento da aggiornare
  editAvailables(availablesId: number) {
    this.availablesId = availablesId
    this.available = this.getAvailablesByIndex(availablesId)
    this.availablesEditMode.next(availablesId);
  }

  // metodo richiamato all'inserimento di un nuovo pannello; viene identificata la posizione nella tabella dell'elemento da aggiungere
  setAvailables(availables: Availables[]) {
    if (availables !== null) {
      this.availables = availables;
      this.availablesChanged.next(this.availables.slice());
    }
  }

  // metodo che restituisce l'intero oggetto "pannello" in base alla posizione nella tabella
  getAvailablesByIndex(id: number) {
    return this.availables.find(x => x.id === id);
  }

  // metodo che restituisce tutti i pannelli memorizzati localmente
  getAvailables() {
    return this.availables;
  }

  // metodo che inserisce il nuovo pannello appena inserito nell'array locale contenente tutti i pannelli, aggiornando la tabella
  addAvailables(availables: Availables) {
    availables.id = this.availables.length;
    this.availables.push(availables);
    this.availablesChanged.next(this.availables.slice());
  }

  // metodo che aggiorna il pannello appena modificato nell'array locale contenente tutti i pannelli, aggiornando la tabella
  updateAvailables(index: number, availables: Availables) {
    this.availables[index] = availables;
    this.availablesChanged.next(this.availables.slice());
  }

  // metodo che individua la posizione del pannello appena cancellato, aggiorna la tabella e l'array locale contenente tutti i pannelli
  deleteAvailables(id) {
    var elementPos = this.availables.map(function (x) { return x.id; }).indexOf(id);
    this.availables.splice(elementPos, 1);
    this.availablesChanged.next(this.availables.slice());
  }
}
